import React, {
  useEffect,
  useState,
  useMemo,
  useRef,
  useCallback,
} from "react";
import { FaFilter } from "react-icons/fa";
import { AiFillAppstore } from "react-icons/ai";
import Add from "@mui/icons-material/Add";
import axios from "axios";
import swal from "sweetalert";

import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-material.css";
import Loader from "../Loader/Loader";
import Apiservice from "../../Services/Apiservice";

const DietPrescribed = () => {
  // Search Food
  const [loading, setLoading] = useState(false);
  const [posts, setPosts] = useState([]);
  const [searchTitle, setSearchTitle] = useState("");
  useEffect(() => {
    const loadPosts = async () => {
      setLoading(true);
      const response = await Apiservice.get(
        "/medicineapi/"
      );
      setPosts(response.data);
      // // //console.log(response.data);
      setLoading(false);
    };
    loadPosts();
  }, []);

  //   GET MEDICINE DETAILS

  const MedicineIDtoGetDetails = localStorage.getItem("MedicineID");
  const [medicinedetailsindoctor, setMedicinedetails] = useState([]);
  const [response, setresponse] = useState();

  useEffect(() => {
    Apiservice
      .get(
        `/medicinebyidapi/${MedicineIDtoGetDetails}/`
      )

      .then((response) => {
        setMedicinedetails(response.data[0]);
        // // //console.log("MedicinebyID", response.data);
      })
      .catch((err) => {});
  }, [MedicineIDtoGetDetails]);

  const [opentwo, setOPentwo] = useState(false);
  const toggletwo = () => {
    setOPentwo(!opentwo);
  };

  const patientIDforPrescription = localStorage.getItem("patientUserName");
  const DoctorNameforPrescription = localStorage.getItem("id");
  const [morning, setmorning] = useState("");
  const [afternoon, setafternoon] = useState("");
  const [evening, setevening] = useState("");
  const [nignt, setnignt] = useState("");
  const [comment, setcomment] = useState("");
  const [dosage, setdosage] = useState("");
  const [duration, setduration] = useState("");

  // POST DIET
  const CreateAppointment = async (e) => {
    e.preventDefault();
    await Apiservice
      .post(
        // `https://djangoobesitychat.azurewebsites.net/prescriptionapi/user/${patientIDforPrescription}/`,
        `/prescriptionapi/user/${patientIDforPrescription}/`,

        {
          patient_name: patientIDforPrescription,
          doctor_id: DoctorNameforPrescription,
          medicine_name: medicinedetailsindoctor.medicine_name,
          dosage: dosage,
          duration: duration,
          morning: morning,
          afternoon: afternoon,
          evening: evening,
          night: nignt,
          comment: comment,
        }
      )
      .then((res) => {
        swal({
          title: "Diet to the Patient Prescriptionfor Diet Added Successfully",
          className: "successAlert",
          buttons: true,
          timer: 3000,
        });
        fetch(
          `https://djangoobesitychat.azurewebsites.net/prescriptionapi/user/${patientIDforPrescription}/`
        )
          .then((data) => data.json())
          .then((data) => setTableData(data));
      })
      .catch((res) => {
        // // //console.log("err", res.response.data);
        setresponse(res.response.data);
      });
  };

  // EXISTING PRESCRIBED DIET DATA GET
  function ImageCellRenderer(params) {
    const imageUrl = params.value;
    return <img style={{ height: "3em" }} src={imageUrl} alt="Cell" />;
  }
  const gridRef = useRef();
  const [columnDefs, setColumnDefs] = useState([
    { field: "prescription_id", filter: true, headerName: "ID" },
    { field: "medicine_name", filter: true, headerName: "Food Name" },
    { field: "comment", headerName: "Comment" },
    { field: "doctor_id", headerName: "Doctor ID" },
  ]);
  const defaultColDef = useMemo(() => ({
    flex: 1,
    sortable: true,
    filter: "agTextColumnFilter",
    resizable: true,
    suppressToolPanel: true,
  }));
  const onFilterTextBoxChanged = useCallback(() => {
    gridRef.current.api.setQuickFilter(
      document.getElementById("filter-text-box").value
    );
  }, []);
  const [tableData, setTableData] = useState([]);
  useEffect(() => {
    fetch(
      `https://djangoobesitychat.azurewebsites.net/prescriptionapi/user/${patientIDforPrescription}/`
    )
      .then((data) => data.json())
      .then((data) => setTableData(data))
      .then(setLoading(false));
  }, []);

  // // //console.log("Prescription Table", tableData);

  return (
    <div>
      <div className="paient-list-top-main-flex-div">
        <div className="paient-list-top-main-width-div">
          <div className="paient-list-top-main-div">
            <div className="table-page-middle-nav-main-div">
              <div>
                <p style={{ fontWeight: "600", fontSize: "18px" }}>
                  Diet Prescription
                </p>
              </div>

              <div>
                <input
                  className="pateint-search-input-tag"
                  type="text"
                  placeholder="Search Food..."
                  onClick={toggletwo}
                  onChange={(e) => setSearchTitle(e.target.value)}
                />
                {opentwo && (
                  <div className="list-of-all-user" onClick={toggletwo}>
                    {loading ? (
                      <div style={{ display: "none" }}></div>
                    ) : (
                      posts
                        .filter((value) => {
                          if (searchTitle === "") {
                          } else if (
                            value.medicine_name
                              ?.toLowerCase()
                              .includes(searchTitle?.toLowerCase())
                          ) {
                            return value;
                          }
                        })
                        .map((item) => (
                          <div className="list-of-user-main-flex-div">
                            <div className="list-of-user-main-div">
                              <p
                                onClick={() =>
                                  localStorage.setItem("MedicineID", item.id)
                                }
                              >
                                {item.medicine_name}
                              </p>
                            </div>
                          </div>
                        ))
                    )}
                  </div>
                )}
              </div>

              <div className="table-pg-middle-nav-scnd-div"></div>
            </div>
          </div>
        </div>
      </div>

      <div className="doctor-prescr-flex-div">
        <div className="doctor-prescr-width-div">
          <div className="doctor-prescr-main-div">
            <div className="doctor-prescr-sub-div-one" style={{ width: "30%" }}>
              <h3>Food</h3>
            </div>
            {/*<div className="doctor-prescr-sub-div-two" style={{ width: "15%" }}>
              <h3>Dosage</h3>
                              </div>*/}
            <div
              className="doctor-prescr-sub-div-three"
              style={{ width: "30%" }}
            >
              <h3>Frequency</h3>
            </div>
            <div
              className="doctor-prescr-sub-div-four"
              style={{ width: "20%" }}
            >
              <h3>Duration</h3>
            </div>
            <div
              className="doctor-prescr-sub-div-four"
              style={{ width: "20%" }}
            >
              <h3>Comment</h3>
            </div>
          </div>

          <div className="doctor-prescr-main-div">
            <div className="doctor-prescr-sub-div-one" style={{ width: "30%" }}>
              <p>{medicinedetailsindoctor.medicine_name}</p>
            </div>

            <div
              className="doctor-prescr-sub-div-three"
              style={{
                display: "flex",
                justifyContent: "space-between",
                width: "30%",
                alignItems: "center",
              }}
            >
              <div style={{ display: "flex", gap: "3px" }}>
                <input
                  type="checkbox"
                  value={"true"}
                  onChange={(e) => setmorning(e.target.value)}
                  // checked={true}
                />{" "}
                <p>Morning</p>
              </div>
              <div style={{ display: "flex", gap: "3px" }}>
                <input
                  type="checkbox"
                  value={"true"}
                  onChange={(e) => setafternoon(e.target.value)}
                  // checked={true}
                />{" "}
                <p>Afternoon</p>
              </div>
              <div style={{ display: "flex", gap: "3px" }}>
                <input
                  value={"true"}
                  onChange={(e) => setevening(e.target.value)}
                  // checked={true}
                  type="checkbox"
                />{" "}
                <p>Evening</p>
              </div>
              <div style={{ display: "flex", gap: "3px" }}>
                <input
                  type="checkbox"
                  value={"true"}
                  onChange={(e) => setnignt(e.target.value)}
                  // checked={true}
                />{" "}
                <p>Night</p>
              </div>
            </div>
            <div
              className="doctor-prescr-sub-div-four"
              style={{
                // display: "flex",
                gap: "5px",
                justifyContent: "center",
                width: "20%",
              }}
            >
              <div
                style={{
                  display: "flex",
                  gap: "5px",
                  justifyContent: "center",
                  // width: "20%",
                }}
              >
                <input
                  type={"number"}
                  placeholder="days"
                  // className="dosage-input-field"
                  value={duration}
                  onChange={(e) => setduration(e.target.value)}
                />
                <p>Days</p>
              </div>
              <div className="error-message-preview">
                <p>{response && response.duration}</p>
              </div>
            </div>

            <div className="doctor-prescr-sub-div-two" style={{ width: "20%" }}>
              <input
                type={"text"}
                placeholder="Comment"
                value={comment}
                onChange={(e) => setcomment(e.target.value)}
              />
            </div>
          </div>

          {/*     
          <div>
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 550 }} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell align="center">Medicine Name</TableCell>
                    <TableCell align="center">Generic Name</TableCell>
                    <TableCell align="center">Dosage</TableCell>
                    <TableCell align="center">Frequency</TableCell>
                    <TableCell align="center">Duration</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow
                    // key={row.name}
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  >
                    
                    <TableCell align="center">Lomaira</TableCell>
                    <TableCell align="center">Phentermine</TableCell>
                    <TableCell align="center">15mg</TableCell>
                    <TableCell align="center">1-0-0</TableCell>
                    <TableCell align="center">60 Days</TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </div>

        */}
        </div>
      </div>

      <div className="add-pat-btn-div">
        <button className="add-btn-btn-tag" onClick={CreateAppointment}>
          <Add style={{ height: "20px", width: "20px" }} />
          SUBMIT PRESCRIPTION
        </button>
      </div>

      {loading ? (
        <Loader />
      ) : (
        <div
          className="ag-theme-material"
          style={{
            width: "100%",
            height: "90vh",
            boxShadow: "rgb(0 0 0 / 35%) 0px 5px 15px",
            marginTop: "20px",
          }}
        >
          <AgGridReact
            ref={gridRef}
            rowData={tableData}
            columnDefs={columnDefs}
            defaultColDef={defaultColDef}
            animateRows={true}
            rowSelection="multiple"
          />
        </div>
      )}
    </div>
  );
};

export default DietPrescribed;
